const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="flex items-center justify-center h-16 bg-[#54B0AF]">
      <p className="text-[12px] lg:text-lg font-gotham text-white text-center">
        © {year} All Rights Reserved
      </p>
    </footer>
  );
};

export default Footer;
